import { Injectable, OnInit, Directive, Self } from '@angular/core';

import { CollapseContainerDirective } from './collapse-container.directive';

@Injectable()
export class ParentConfiguration {
  name: string;
  parent: CollapseParentDirective;
}

@Directive({
  selector: '.collapse-parent',
  providers: [ParentConfiguration]
})
export class CollapseParentDirective implements OnInit {

  parentConfig;

  containers: CollapseContainerDirective[] = [];

  constructor(@Self() parentConfig: ParentConfiguration) {
    this.parentConfig = parentConfig;
  }

  ngOnInit() {
    if (this.parentConfig) {
      this.parentConfig.parent = this;
    }
  }

  activate(activated: CollapseContainerDirective) {
    this.containers
      .filter(m => m !== activated)
      .forEach((v) => {
        v.collapse(true);
      });
  }
}
